"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getInstrumentationContextsFromTableView_1 = require("owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView");
var getItemIdsFromConversations_1 = require("owa-mail-list-store/lib/utils/getItemIdsFromConversations");
var markItemsJunkNotJunkBasedOnItemIds_1 = require("./helpers/markItemsJunkNotJunkBasedOnItemIds");
var actionTypes_1 = require("owa-mail-store/lib/actions/actionTypes");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
/**
 * The action which marks conversations as junk.
 * @param conversationRowKeys - the conversations rows to mark as junk
 * @param tableView - the table view the conversations are from
 * @param isJunkValueToSet - whether it is a mark as junk or not junk action
 * @param actionSource - the source that initiated the action call
 */
function markConversationsJunkNotJunkFromTable(conversationRowKeys, tableView, isJunkValueToSet, actionSource) {
    // the itemIds need to be retrieved before the store update, otherwise it might get removed
    var itemIdsToUpdate = getItemIdsFromConversations_1.default(conversationRowKeys, tableView.id);
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(conversationRowKeys, tableView);
    markItemsJunkNotJunkBasedOnItemIds_1.default(itemIdsToUpdate, isJunkValueToSet, actionSource, instrumentationContexts, function () {
        // remove conversation from list view and reading pane store
        var conversationIds = owa_mail_list_store_1.getRowIdsFromRowKeys(conversationRowKeys, tableView.id);
        stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIds, tableView);
    });
}
exports.default = markConversationsJunkNotJunkFromTable;
//# sourceMappingURL=markConversationsJunkNotJunkFromTable.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/markConversationsJunkNotJunkFromTable.js
// module id = 5660
// module chunks = 62